import CheckIcon from '@mui/icons-material/Check';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useTranslate } from '@si/utils';
import { useState } from 'react';

import { Button } from '../Button/Button';

interface Props {
  content: string;
  ariaLabel?: string;
}

export function CopyContentButton({ content, ariaLabel }: Props) {
  const { t, translate } = useTranslate();
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(content);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Button
      variant="text"
      size="small"
      startIcon={copied ? <CheckIcon /> : <ContentCopyIcon />}
      onClick={handleCopy}
      aria-label={ariaLabel ?? translate(t.copy)}
    >
      {copied ? translate(t.copied) : translate(t.copy)}
    </Button>
  );
}
